<template>
  <div class="mb-2">
    <AppFilter
      :filters="filterConfig"
      :filter-submitting="filterSubmitting"
      :hide-header="true"
      :initial-values="values"
      @filter="handleFilter"
    />
  </div>
</template>

<script>
import AppFilter from '@/components/AppFilter/AppFilter.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'MyOrdersFilter',
  components: {
    AppFilter
  },
  props: {
    values: {
      type: Object,
      required: true
    },
    filterSubmitting: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      countries: 'app/countries'
    }),
    filterConfig() {
      return [
        {
          id: 'search',
          label: 'Order Or Buyer Name',
          type: 'text',
          placeholder: 'Order Or Buyer Name Placeholder'
        },
        {
          id: 'country',
          label: this.$t('Recipient Country'),
          type: 'select',
          options: this.countries || [],
          placeholder: this.$t('Recipient Country')
        },
        {
          id: 'shipmentStatus',
          label: 'Shipment Status',
          type: 'select',
          options: [
            { text: this.$t('Consignment Created'), value: true },
            { text: this.$t('Consignment Not Created'), value: false }
          ],
          placeholder: 'Shipment Status'
        },
        {
          id: 'orderStatus',
          label: 'Order Status',
          type: 'select',
          options: [
            { text: this.$t('Active'), value: 'INSTRUCT' },
            { text: this.$t('Cancelled'), value: 'CANCEL' }
          ],
          placeholder: 'Order Status'
        },
        {
          id: 'dateRange',
          label: 'Date',
          type: 'daterange',
          placeholder: 'Date Range Placeholder'
        }
      ];
    }
  },
  async created() {
    if (!this.countries || this.countries.length === 0) {
      await this.$store.dispatch('app/getCountries');
    }
  },
  methods: {
    handleFilter(values) {
      this.$emit('filter', values);
    }
  }
};
</script>
